import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson41: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson40"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Magnesium</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson42"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full h-[699.88rem] flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Evidence-Based Health Benefits of Magnesium</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Magnesium is crucial for your brain and body. It has many
                  benefits, including for your heart, blood sugar levels, and
                  mood. It’s found in various foods ranging from leafy greens to
                  nuts, seeds, and beans.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Magnesium is found throughout your body. Every cell in your
                  body contains this mineral and needs it to function.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  About 60% of the magnesium in your body occurs in bone, while
                  the rest is in muscles, soft tissues, and fluids, including
                  blood.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  One of its main roles is to act as a co factor — a helper
                  molecule — in the biochemical reactions continuously performed
                  by enzymes. It’s involved in more than 600 reactions in your
                  body, including:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Energy creation: converting food into energy</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Protein formation: creating new proteins from amino acids
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Gene maintenance: helping create and repair DNA and RNA
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Muscle movements: aiding in muscle contraction and
                    relaxation
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Nervous system regulation: regulating neurotransmitters,
                    which send messages throughout your brain and nervous system
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Nonetheless, studies suggest that approximately 50% of U.S.
                  adults get less than the recommended daily amount of
                  magnesium.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Magnesium supports hundreds of chemical reactions in your
                  body. However, many people get less than they need.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Boosts Exercise Levels</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    You may need more magnesium during exercise than when you’re
                    resting, depending on the activity.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Magnesium helps move blood sugar into your muscles and
                    dispose of lactate, which can build up during exercise and
                    cause fatigue.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Studies show magnesium supplements may be particularly
                    beneficial for improving exercise performance in older
                    adults and those with a deficiency in this nutrient.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    One older study of 2,570 women associated higher magnesium
                    intake with increased muscle mass and power.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    In a 2019 study, professional male cyclists players who took
                    400 mg of magnesium per day for 3 weeks experienced
                    improvements in muscle recovery and protection from muscle
                    damage following a strenuous race, compared to cyclists
                    taking a placebo.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    However, more studies are needed, as some research suggests
                    that supplementing doesn’t help athletes or active people
                    with adequate magnesium levels.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>SUMMARY</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Magnesium supplements have been shown to enhance exercise
                    performance in several studies, but results are mixed.
                  </span>
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Depressive Combat</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Magnesium plays a critical role in brain function and mood;
                  low levels are linked to an increased risk of depression.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A 2020 review suggested that stress may deplete magnesium,
                  increasing susceptibility to stress and depression.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  What’s more, supplementing with this mineral may help reduce
                  symptoms of depression.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In one small 8-week study, taking 500 mg of magnesium daily
                  led to significant improvements in symptoms of depression in
                  people with a deficiency in this mineral.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Plus, a 6-week study in 126 people showed that taking 248 mg
                  of magnesium per day decreased symptoms of depression and
                  anxiety, regardless of magnesium status.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Magnesium deficiency may be linked to depression. As such,
                  supplementing may help reduce symptoms of depression.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>May Support Healthy Blood Sugar Levels</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Studies suggest that about 48% of people with type 2
                    diabetes have low blood levels of magnesium, which may
                    impair the body’s ability to regulate blood sugar levels
                    effectively.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Additionally, research indicates that people who consume
                    more magnesium have a lower risk of type 2 diabetes.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    According to one review, magnesium supplements help enhance
                    insulin sensitivity, a key factor in blood sugar control.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Another review reported that magnesium supplements improved
                    blood sugar levels and insulin sensitivity in people at risk
                    for type 2 diabetes.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>SUMMARY</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Magnesium supplements may improve blood sugar levels,
                    insulin sensitivity, and other risk factors for type 2
                    diabetes.
                  </span>
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Promoting Heart Health</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Magnesium plays an important role in keeping your heart
                    healthy and strong.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    A 2021 review shows that magnesium supplements can help
                    lower high blood pressure levels, which may be a risk factor
                    for heart disease.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Another review linked high magnesium intake to a lower risk
                    of heart disease, stroke, and high blood pressure.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    What’s more, one review found that magnesium supplements
                    improved multiple risk factors for heart disease, including
                    triglyceride, LDL (bad) cholesterol, HDL (good) cholesterol,
                    and systolic blood pressure levels, especially in people
                    with a magnesium deficiency.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    However, more research is needed, as other research has
                    found no effect of magnesium on cholesterol or triglyceride
                    levels.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>SUMMARY</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Magnesium may help lower blood pressure levels and reduce
                    several risk factors for heart disease. Still, more research
                    is needed.
                  </span>
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Boasts Anti-Inflammatory Benefits</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Low magnesium intake is linked to increased levels of
                  inflammation, which plays a crucial role in aging and chronic
                  disease.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  One review of 11 studies concluded that magnesium supplements
                  decreased levels of C-reactive protein (CRP), a marker of
                  inflammation, in people with chronic inflammation.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Other studies report similar findings, showing that magnesium
                  supplements may reduce CRP and other markers of inflammation,
                  such as interleukin-6.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Furthermore, some research ties magnesium deficiency to
                  increased oxidative stress, which is related to inflammation.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Magnesium has been shown to help fight inflammation by
                  reducing markers such as CRP and interleukin-6.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Migraine Prevention</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Migraine headaches can be painful and often cause nausea,
                  vomiting, and sensitivity to light and noise.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Some researchers believe that people with migraine are more
                  likely than others to have a magnesium deficiency.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Several studies suggest that magnesium supplements may even
                  prevent and treat migraine headaches.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In one older study, supplementing with 1 gram of magnesium
                  provided relief from acute migraine attacks more quickly and
                  effectively than a common medication.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Eating more magnesium-rich foods may also help reduce migraine
                  symptome.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  People with migraine may have low magnesium levels. Some
                  studies show that supplementing with this mineral may provide
                  relief from migraine attacks.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>May Improve PMS Symptoms</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Premenstrual syndrome (PMS) is one of the most common
                  conditions in female-bodied people of childbearing age. It
                  often causes symptoms, such as water retention, abdominal
                  cramps, tiredness, and irritability.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Some research suggests that magnesium supplements help relieve
                  PMS symptoms and other conditions such as menstrual cramps and
                  migraine attacks.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  This may be because magnesium levels fluctuate throughout the
                  menstrual cycle, worsening PMS symptoms in those with a
                  deficiency. As such, supplements may help reduce the severity
                  of symptoms, including menstrual migraine attacks.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  One study found that taking 300 mg of magnesium daily helped
                  decrease bloating, depression, and anxiety in college students
                  with PMS compared with a control group.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Still, more recent, high quality studies are needed to
                  determine whether this mineral can improve symptoms regardless
                  of your magnesium levels.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Some studies suggest that magnesium supplements help improve
                  PMS symptoms, though more research is necessary.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Promotes Bone Health</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Magnesium is crucial for maintaining bone health and
                  protecting against bone loss. In fact, 50–60% of your body’s
                  magnesium is found in your bones.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Some studies associate lower levels of this mineral with a
                  higher risk of osteoporosis, which causes bones to become
                  brittle and weak.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A 3-year study in 358 people undergoing hemodialysis — a
                  treatment to help remove waste and water from the blood —
                  showed that those who consumed the least magnesium experienced
                  three times more fractures than those with the highest intake.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Moreover, one recent review of 12 studies linked high
                  magnesium intake to increased bone mineral density in the hip
                  and femoral neck, both areas susceptible to fracture.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Magnesium is important for bone health. Some studies tie a
                  higher intake to a lower risk of osteoporosis, fractures, and
                  bone loss.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Improved Sleep</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Magnesium supplements are often used as a natural remedy for
                  sleep issues such as insomnia.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  This is because magnesium regulates several neurotransmitters
                  involved in sleep, such as gamma aminobutyric acid.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  One review of older adults with insomnia found that magnesium
                  supplements lowered the amount of time it took people to fall
                  asleep by an average of 17 minutes.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Another study in nearly 4,000 adults linked increased intake
                  of this mineral to improved sleep quality and duration.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Furthermore, another study associated higher magnesium intake
                  in women with a reduced likelihood of falling asleep during
                  the daytime.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Increasing your intake of magnesium through foods or
                  supplements may help treat certain sleep issues and improve
                  sleep quality.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Anxiety Reduction</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Some research suggests that magnesium helps treat and prevent
                  anxiety.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  For example, one study of 3,172 Iranian adults associated
                  increased magnesium intake with a lower risk of depression and
                  anxiety.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Similarly, a small 6-week study found that taking 248 mg of
                  magnesium daily significantly reduced anxiety symptoms.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Other research suggests that magnesium deficiency may increase
                  your body’s susceptibility to stress, which may amplify
                  symptoms of anxiety.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  One review concluded that magnesium supplements might help
                  reduce mild to moderate anxiety but noted that research is
                  conflicting — and that the effects of supplements haven’t been
                  studied beyond 3 months.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Magnesium may help reduce symptoms of anxiety and decrease
                  stress, but more studies are needed.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Magnesium is essential for many aspects of health. The recommended
            daily intake is 400–420 mg for males and 310–320 mg for females.
          </p>
          <p className="m-0">
            You can get this mineral from both food and supplements.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Food Sources</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>The following foods are rich in magnesium:</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Pumpkin seeds:</b>
                  <span> 37% of the DV per ounce (28 grams)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Chia seeds: `}</b>
                  <span>26% of the DV per ounce (28 grams)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Spinach, boiled:</b>
                  <span> 19% of the DV per 1/2 cup (90 grams)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Almonds: `}</b>
                  <span>19% of the DV per ounce (28 grams)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Cashews:</b>
                  <span> 18% of the DV per ounce (28 grams)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Black beans, cooked:</b>
                  <span> 14% of the DV per 1/2 cup (86 grams)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Edamame, cooked: `}</b>
                  <span>12% of the DV per 1/2 cup (78 grams)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Peanut butter: `}</b>
                  <span>12% of the DV per 2 tablespoons (32 grams)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Brown rice, cooked: `}</b>
                  <span>10% of the DV per 1/2 cup (100 grams)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Salmon, cooked:</b>
                  <span> 6% of the DV per 3 ounces (85 grams)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Halibut, cooked:</b>
                  <span> 6% of the DV per 3 ounces (85 grams)</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b className="font-dm-sans">{`Avocado: `}</b>
                  <span>5% of the DV per 1/2 cup (75 grams)</span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Supplements</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  If you have a medical condition, check with your doctor before
                  taking magnesium supplements. Though these supplements are
                  generally well tolerated, they may be unsafe for people who
                  take certain diuretics, heart medications, osteoporosis
                  medications, proton pump inhibitors, or antibiotics.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Getting enough magnesium is vital for your health. Many foods
                  contain it, and many high quality supplements are available.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>The Bottom Line</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Magnesium is essential for maintaining good health and plays a
                  key role in everything from exercise performance to heart
                  health and brain function.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Enjoying a variety of magnesium-rich foods may ensure you’re
                  getting enough of this nutrient in your diet. Spinach, chia
                  seeds, peanut butter, and avocados are a few examples that
                  make great additions to smoothies, snacks, and other dishes.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Some multivitamin formulations may contain magnesium, and
                  magnesium supplements don’t typically cause side effects.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Still, study results should be interpreted with a grain of
                  salt. Following a balanced diet is more important than
                  focusing on a single nutrient. Remember that magnesium is not
                  guaranteed to provide any of the results above.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Many whole grains are also high in B vitamins, selenium,
                  manganese, and fiber.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In controlled studies, whole grains have even been shown to
                  reduce inflammation and decrease several risk factors for
                  heart disease.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Whole grains are high in many nutrients, including magnesium.
                  A 1-cup (168-g) serving of cooked buckwheat provides 20% of
                  the DV for magnesium.
                </span>
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson42"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson41;
